exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "a[data-v-1b1ea6c3] {\n  cursor: pointer;\n}\n", "", {"version":3,"sources":["/home/vsts/work/1/s/apps/client/vendor/Pagination.vue"],"names":[],"mappings":"AACA;EACE,gBAAe;CAAA","file":"Pagination.vue?vue&type=style&index=0&id=1b1ea6c3&lang=css&scoped=true&","sourcesContent":["\na {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports
